import { GeneratedContent } from '@contentTransformation/types/contentTransformation';

export const generatedContent: GeneratedContent = {
  hospoda: [
    {
      type: 'title',
      data: [
        'Kamarádský kvas',
        'Pivní přátelství',
        'Milovníci Maltu',
        'Pivní parťáci',
        'Kumpáni kvasu',
        'Kámošské kvašení',
        'Pivo a přátelé',
        'Kamarádské pivo',
        'Pivní výprava',
        'Večer plný piva',
        'Pivní společnost',
        'Party v hospodě',
        'Pivní orgie',
        'Konec kratochvílí v kavárně',
        'Poslední pivo posádky',
        'Napijme se s přáteli',
        'Výčepní víkendové vyvrcholení',
        'Hospodské hody',
        'Poslední panáky při západu slunce',
        'Konečná kulminační Kofola',
        'Noc nápojů a vzpomínek',
        'Pivní posezení',
        'Hospodský večer s kamarády',
        'Hanging out v hospodě',
        'Pivní setkání',
        'Relax v hospodě',
        'Živé pivko s kamarády',
        'Chill-out v hospodě',
        'Pivo a pokec',
        'Relaxační after-work pivko',
        'Setkání u piva',
        'Uvítání víkendu v hospodě',
        'Sklenka piva s přáteli',
        'Pivní happy hour',
        'Živá hudba a pivko',
        'Pivní degustace s kámošema',
        'Happy hour v hospodě',
        'Barová noc s přáteli',
        'Pivní toulky po hospodách',
        'Pojďme si dát pivo!',
        'Posezení v místní hospodě',
        'Pivní chvíle s kamarády',
        'Společná noc v hospodě',
        'Pivní setkání s kamarády',
        'Relaxační pivko s přáteli',
        'Hospodský chill-out s přáteli',
        'Uvolněný večer v hospodě',
        'Barové posezení s kamarády',
        'Hospodská párty',
        'Setkání v místní hospodě',
        'Přátelské pivní večery',
        'Uvítání víkendu s přáteli v hospodě',
        'Pivočichové dobrodružství',
        'Osmé pivko s kamarády',
        'Hrdinové za barem',
        'Společné uvítání víkendu',
        'Parta kamarádů a pivo',
        'Kámošský hospodský mejdan',
        'Pivní olympiáda',
        'Pivo a další neřesti',
        'Kamarádi v akci - u piva',
        'Pivo, pizza a přátelé',
        'Sraz na pěnu nebo pěnu na sraz',
        'Tak pojďme na chvíli posedět!',
        'Hospodské šílenství s kamarády',
        'Plán B: posezení s přáteli a pivem',
        'Hospodská parta - stále v kurzu',
        'Kamarádi a k tomu pivko',
        'Pivo, přátelé a osvobození od reality',
        'Štamgasti na palubě',
        'Kamarádská pivní válka',
        'Kámoši, pivo a nejlepší zábava',
        'Pivo a posvátné kamarádství',
        'Osvobozující setkání s kamarády',
        'Pivní štěstí s přáteli',
        'Užij si to s kamarády v hospodě',
        'Hospodská štace',
        'Hospodský nájezd',
        'Hospoda po práci? Vždycky!',
        'Kamarádské posezení',
        'Hospodský Pit stop',
        'Zasloužená hospoda s přáteli',
        'Hospodská chálka s kámoši',
        'Pivo s partou',
        'Kamarádský půllitr',
        'Pivní degustace',
        'Tak zajdem na jedno?!',
        'Dycky Hospa',
      ],
    },
    {
      type: 'description',
      data: [
        'Za pár dní se sejdeme s přáteli v hospodě na neformálním setkání. Probereme zážitky, plány do budoucna, a užijeme si uvolněnou atmosféru.',
        'Plánujeme sejít se s přáteli v hospodě, kde si užijeme uvolněnou atmosféru a probereme aktuální témata.',
        'Za chvíli se potkáme v hospodě a strávíme spolu příjemné odpoledne.',
        'Těšíme se na setkání v hospodě, kde si dáme pár piv a pohovoříme o životě.',
        'Přemýšlíme, že bychom se sešli v hospodě, kde si dáme pivko a pokecáme o zážitcích a o životě.',
        'Máme v plánu sejít se s kamarády v hospodě. Strávíme příjemné odpoledne a pokecáme o všem možném.',
        'S kamarády jsme se rozhodli, že se sejdem v hospodě na pár piv a užijem si uvolněnou atmosféru.',
        'Chystáme se na posezení s přáteli v hospodě, kde si užijeme skvělou atmosféru a sklenku dobrého piva.',
        'Přemýšlíme, že bychom si s kamarády zašli do hospody na pár osvěžujících drinků a příjemnou konverzaci.',
        'Těšíme se na setkání v hospodě, kde si dáme dobré pivo a pokecáme.',
        'Chceme se sejít s kamarády v hospodě, kde si užijeme dobré pití a příjemnou společnost.',
        'Plánujeme si zajít do hospody, kde si dáme něco dobrého k pití a pobavíme se s přáteli.',
        'Těšíme se na neformální setkání s kamarády v hospodě, kde si dáme pár piv a povíme si o našich zážitcích.',
        'S přáteli se chystáme na neformální setkání v hospodě, kde si užijeme uvolněnou atmosféru a příjemnou konverzaci.',
        'Máme v plánu zajít do hospody s kamarády, kde si dáme dobré pivo a probereme aktuální dění.',
        'Přemýšlíme o setkání v hospodě s přáteli, kde si dáme něco dobrého k pití a pokecáme o životě.',
        'Sejdeme se v hospodě na pivu, abychom zapomněli na naše problémy, tedy alespoň na chvíli.',
        'S kamarády jsme si říkali, že bychom si mohli zajít do hospody a udělat průzkum, kolik piv je potřeba, aby se člověk cítil šťastně.',
        'Zvažujeme, že se setkáme v hospodě a provedeme sociologický výzkum, kolikrát za hodinu si člověk dokáže objednat nové pivo.',
        'Plánujeme zajít do hospody, kde se budeme snažit vyřešit všechny světové problémy, alespoň tedy do konce večera.',
        'S kamarády jsme se domluvili na setkání v hospodě, kde si budeme navzájem dávat rady, které v životě nikdy nepoužijeme.',
        'Přemýšlíme, že bychom se sešli v hospodě a udělali malou průzkumnou misi a zjistili, co je lepší, jestli pivo nebo voda.',
        'Chceme se sejít s přáteli v hospodě, kde si dáme pivo a budeme se snažit najít odpověď na otázku, proč se svět točí.',
        'Máme v plánu zajít do hospody, kde si budeme vyprávět vtipy tak dlouho, až nás začnou bolet břicha. A pak si dáme další pivo!',
        'S přáteli jsme si říkali, že bychom si mohli zajít do hospody a zjistit, kolik piv je potřeba, aby se nám naše nápady zdály geniální a vtipné.',
        'Přemýšlíme, že bychom se sešli v hospodě a udělali test, kolik piv jsou schopni vypít za večer lidé s různou úrovní tolerance alkoholu.',
        'Sejdeme se s kamarády v hospodě, dáme pivo a budeme si představovat, jak by svět vypadal, kdyby se všichni chovali jako my.',
        'Za chvíli se v hospodě setkáme s přáteli a pokusíme se vypít místní zásoby (nejen) piva.',
        'Všichni se už těšíme na setkání v hospodě, kde se budeme pokoušet vyhrát ve všech druzích stolních her.',
        'S přáteli plánujeme pěkně oživit hospodskou atmosféru, takže se připravte na náš zpěv a taneční kreace.',
        'V hospodě budeme prožívat epické dobrodružství s přáteli, budeme se totiž snažit ochutnat všechna piva na čepu.',
        'Za pár dní se sejdeme v hospodě, kde si budeme moct vychutnat chvíle bez obav o naše kalorické příjmy.',
        'S kamarády se setkáme v hospodě, kde si dáme dobré pivo a budeme se bavit o důležitých věcech, jako jsou třeba filmy a seriály.',
        'V hospodě se setkáme se všemi kámoši, kteří se nám za poslední roky podařilo někde ztratit, takže se připravte na neuvěřitelné příběhy.',
        'S kamarády se setkáme v hospodě, kde si dáme pár piv a budeme si stěžovat na naše každodenní problémy.',
        's přáteli se budeme setkávat v hospodě pravidelně každý měsíc, což je dostatečný interval, aby se nám nezačalo stýskat.',
        'V hospodě se budeme společně snažit pokořit rekord v počtu vypitých piv, který zůstal nezměněn po desetiletí.',
        'Za chvíli se sejdeme s přáteli v hospodě, kde budeme moci ochutnat snad všechny druhy piv.',
        'Se všemi se sejdeme v hospodě, kde budeme slavit naše nekonečné přátelství a hlavně ochutnávat nejlepší piva.',
        'Těšíme se na setkání s přáteli v hospodě, kde se pokusíme najít lék na naše pracovní stresy.',
        'S přáteli se setkáme v hospodě, kde budeme slavit každou naši vítěznou bitvu v životě.',
        'Za chvíli se v hospodě setkáme s přáteli, kde si budeme moci oddechnout od každodenních starostí a bavit se o všem možném.',
        'V hospodě se sejdeme s přáteli, kde budeme diskutovat o světových problémech a přitom ochutnávat ty nejlepší piva.',
        'S kamarády se těšíme na setkání v hospodě, kde si budeme moct vychutnat nejlepší piva a smát se těm nejlepším vtipům.',
        'V hospodě se setkáme se všemi kámoši, kteří si zaslouží náš čas a nezapomenutelnou večerní zábavu.',
        'S přáteli se setkáme v hospodě, kde si budeme moct užít naplno život, aniž by nás něco omezovalo.',
        'V hospodě se setkáme s kamarády, budeme se bavit o našich úspěších a neúspěších v životě a přitom ochutnávat ty nejlepší piva.',
        'Těšíme se na setkání s přáteli v hospodě, kde se budeme bavit, smát a užívat si skvělou atmosféru.',
        'S kamarády se setkáme v hospodě, abychom si užili skvělého večera plného zábavy a zážitků.',
        'V hospodě se sejdeme s kamarády, kde budeme společně prožívat nejlepší okamžiky a těšit se na další setkání.',
        'S přáteli se těšíme na setkání v hospodě, kde budeme sdílet své příběhy, sny a plány do budoucna.',
        'V hospodě se setkáme s kamarády, abychom si užili přátelskou atmosféru, popovídali si o aktuálním dění a zasmáli se spolu.',
        'S kamarády se setkáme v hospodě, kde budeme mít možnost poznat nové lidi, sdílet zážitky a rozvíjet naše přátelství.',
        'V hospodě se sejdeme s kamarády, kde budeme moci v klidu posedět, popovídat si a užít si momenty strávené s těmi nejbližšími.',
        'S přáteli se těšíme na setkání v hospodě, kde se budeme cítit jako doma a kde budeme moci zapomenout na všechny starosti a problémy.',
        'V hospodě se setkáme s kamarády, kde budeme mít možnost prožít skvělé chvíle plné zábavy, smíchu a radosti.',
        'Setkáme se v hospodě, kde budeme moci vytvořit nové vzpomínky, navázat nová přátelství a prožít spolu nezapomenutelné zážitky.',
        'Sraz s přáteli v hospodě, kde se všechno dá, ale hlavně něco dobrého na zub a výborná zábava.',
        'Vyhledali jsme ten nejlepší bar v okolí, kde můžeme strávit noc v kamarádské společnosti a ukojit naše smysly.',
        'Vyzvali jsme se navzájem na souboj v pití a debatování, a tak se sejdeme v hospodě, abychom si to rozdali.',
        'S kamarády se sejdeme v hospodě, na chvíli utečeme z reality a zapomeneme na všechny naše životní problémy.',
        'V hospodě se setkáme s přáteli, kde se budeme snažit zapomenout na naše nudné práce a utéct do světa fantazie.',
        'Sejdeme se s kamarády, budeme moci řešit naše problémy, a následně se společně smát tomu, jak jsou tyto problémy vlastně hloupé.',
        'S přáteli se sejdeme v hospodě, kde budeme moci ukázat, kdo z nás má nejlepší smysl pro humor a nejvíce zkušeností s alkoholem.',
        'Setkáme se s kamarády, budeme moci oslavit naše úspěchy, zapomenout na neúspěchy a podpořit se navzájem v našich cílech.',
        'S kamarády se setkáme v hospodě, kde budeme moci užít si tu nejlepší zábavu, kterou naše město nabízí.',
        'Sraz s přáteli v hospodě, kde se smí smát, křičet, tleskat a hlavně užívat si společný čas.',
        'Vyhledali jsme si tu nejlepší hospodu, kde nás čeká nekonečná zásoba dobrot a spousta kamarádů, s kterými se zasmějeme.',
        'V hospodě se setkáme s kamarády, kde se budeme moci odreagovat od práce, utéct od reality a užít si pohodový večer.',
        'S přáteli se těšíme na setkání v hospodě, kde budeme moci objevovat nové pivo, koktejly a nealko nápoje a přitom se bavit.',
        'V hospodě se setkáme s kamarády, kde budeme moci vyzkoušet nové hry jako jsou karty, stolní hry nebo videohry, a utkat se v nich.',
        'S kamarády se setkáme v hospodě, kde budeme moci probrat naše oblíbené filmy, seriály, knihy a hudbu, a najít nové inspirace.',
        'V hospodě se setkáme s přáteli, kde budeme moci plánovat naše další dobrodružství, výlety a zážitky, a těšit se na budoucnost.',
        'S kamarády se setkáme v hospodě, kde budeme moci vyzkoušet nové jídlo, posoudit jeho kvalitu, a přitom si užít skvělou společnost.',
        'V hospodě se setkáme s přáteli, kde budeme moci sdílet naše vtipy, historky a srandovní příběhy.',
        'S kamarády se setkáme v hospodě, kde budeme moci probrat naše největší sny, plány a cíle a podpořit se navzájem v jejich dosažení.',
        'Už se nemůžu dočkat, až se sejdeme v tý nový hospodě s těmi hrozně cool drinky, co jsme viděli na Insta!',
        'Chceme si dát nějaký vychlazený nápoje v tý úplně top hospodě, kde je skvělá muzika a dobrej vibe.',
        'Sraz s kámošema v hospodě, kde je příjemná atmosféra, skvělý servis, a kde můžeme probrat všechny ty gossip news.',
        'Chceme zjistit, co jsou zač nějaký ty nový drinky, co se teď roztáčej v tý úplně trendový hospodě.',
        'S kámošema se těšíme na to, až objevíme nějaký nový koktejly, co nás posadí na zadek!',
        'Sejdem se s kámošema a budem diskutovat o našich oblíbených seriálech a poslouchat naše storky.',
        'V týhle úplně pohodový hospůdce budeme mít vynikající nápoje, jednoduchý menu a skvělou atmosféru, kde budeme moci být sami sebou.',
        'Sejdeme se v hospodě, kde budeme mít možnost ochutnat ty nejzajímavější pivní značky a diskutovat o všem možném.',
        'V týhle úplně super hospodě si objednáme všechno, co máme rádi, od beeru po cool limču, a užijeme si příjemnou společnost.',
        'Kluci a baby, tohle bude super setkání v hospodě, kde probereme všechny nejnovější trendy, ať už v hudbě nebo v módě.',
        'Nazdar kluci a holky! Sejdeme s v nějaké mega super hospodě, kde nás čeká spousta dobrot a chlazených pitíček.',
        'Tak co hoši a dámy, dneska se sejdeme v té nejvíc parádní hospodě v okolí a dáme si spolu ty nejlepší drinky a jídla.',
        'V téhle crazy hospodě se sejdem s kámoši a užijem si nejlepší nápoje a jídla v okolí. Samozřejmě nesmíme zapomenout ani na nějaké fotky.',
        'Máme pro vás plán na super den - setkáme se ve skvělé gastro hospodě ve městě a ochutnáme ty nejlepší speciality.',
        'V týhle chill hospodě se sejdeme s našimi nejlepšími přáteli, užijem si skvělou atmosféru a pak to tam nejvíc rozjedem.',
        'Kluci a baby, tohle bude super setkání v té nejlepší underground hospodě v městě, kde pokecáme o tom, co nás právě teď baví.',
        'V týhle trendy hospodě se sejdeme s našimi nejlepšími kámoši a budeme si užívat nejnovějších hitů a výborných osvěžujících koktejlů.',
        'Dáme sraz společně v hospodě, bude to mega, zahlasujte pro termíny a vidíme se.',
        'Sejdeme se v hospodě a zkusíme to dneska nepřehánět hned od prvního panáka.',
        'Hospoda, dobré pití a skvělá společnost, co víc si přát?',
        'Dneska zasedneme v hospodě a dozvíme se, kdo vydrží nejdéle.',
        'Vemte si dostatek peněz, protože dneska bude dlouhá noc.',
        'Naše stálá tradice - setkání s přáteli v hospodě.',
        'Všichni se sejdeme v hospodě a budeme slavit jakoukoli příležitost, kterou si jen vymyslíme.',
        'Nechte práci doma a přijďte si s námi užít pohodovou atmosféru v hospodě.',
        'Přátelé, pití a fotbálek v hospodě, proč trávit den někde jinde?',
        'Vždycky se nejlíp povídá při pivu v hospodě a ani dnešek nebude vyjímkou.',
        "Když říkám 'hospoda', vy říkáte 'kam?', takže vím, že tohle setkání bude mít úspěch.",
        'Sejdem se, dáme pár osvěžujících nápojů a užijem si příjemné odpoledne v přátelské společnosti.',
        'S kamarády se sejdem v jedné fajn hospůdce, zasmějem se těm nejnovějším memes a probereme všechno důležité.',
        'V hospodě se setkáme se všemi kámoši, které se nám za poslední roky podařilo někde ztratit, takže se připravte na neuvěřitelné příběhy.',
      ],
    },
    {
      type: 'userName',
      data: [
        'Pivní Guru',
        'Bleskový Bob',
        'Zábavný Půllitr',
        'Párty Pecka',
        'Kofeinový Král',
        'Vtipný Viking',
        'Pěnový Profesor',
        'Veselá Kopa',
        'Dobrodružný Divoch',
        'Pivní Poeta',
        'Šprýmař Sam',
        'Rychlá Runda',
        'Zábavný Zoufalec',
        'Koktejlová Královna',
        'Espresso Egon',
        'Rozšafný Bonvián',
        'Koketa Jane',
        'Pivní Poutník',
        'Veselý Výtržník',
        'Běžný Bavič',
        'Kofeinový Kumpán',
        'Vtipný Vagabund',
        'Dobrodružný Dravec',
        'Rychlý Rarášek',
        'Pivní princezna',
        'Pivní Master',
        'Veselá Vtipálka',
        'Barová Židle',
        'Rozverné Martini',
        'Kulatý Stůl',
        'Šumivý Šampán',
        'Veselý Vrkoč',
        'Rychlý Rumburak',
        'Skvělý Šermíř',
        'Bleskový Bubák',
        'Kouzelný Koktejl',
        'Neohrožený Námořník',
        'Polétavá Šenkýřka',
        'Veselý Šenkýř',
        'Štamgast Míchač',
        'Pivní Příživník',
        'Srandovní Šašek',
        'Skvělý Rozumbrada',
        'Báječný Bavič',
        'Přelétavý Přízrak',
        'Kulinářský Kaskadér',
        'Divoký Diskonaut',
        'Pivní Poutník',
        'Chytrá Rozumbrada',
        'Báječný Bonviván',
        'Vtipný Výtržník',
        'Kulinářský Kaskadér',
        'Divoký Dravec',
        'Neposedná Nápadnice',
        'Neposedný Nápadník',
        'Pohodový Přítel',
        'Noční Zvíře',
        'Pivní Pán',
        'Pivní Paní',
        'Rumová Víla',
      ],
    },
  ],
  setkani: [
    {
      type: 'title',
      data: [
        'Přátelská párty na plné otáčky',
        'Směsice smíchu s kamarády',
        'Haha-Hangout',
        'Setkání všech druhů smíchu',
        'Komiksové setkání s kámoši',
        'Nekonečný večer',
        'Sraz smíchu a nejlepších přátel',
        'Humorná harmonie',
        'Směsice šklebů a vtipů',
        'Exploze smíchu s partou',
        'Výlet do země vtipů a smíchu',
        'Zasmání za úsvitu',
        'Veselá výměna anekdot',
        'Parádní setkání s přáteli',
        'Komediální večer s kámoši',
        'Symfonie plná smíchu',
        'Divoký dýchánek',
        'Setkání přátel ve stylu stand-upu',
        'Škádlení a šampaňské',
        'Showtime s partou',
        'Úsměvy a přátelské setkání',
        'Křižovatka komedie a camaraderie',
        'Veselá vlna s kamarády',
        'Hvězdný stand-up večer',
        'Humorná výprava s partou blázínků',
        'Přátelská pařba',
        'Směsice smíchu a šaškáren',
        'Exploze zábavy s partou komiků',
        'Výlet do světa vtipů',
        'Komediální souboj s kamarády',
        'Setkání plné srandy',
        'Hudba, smích a super kámoši',
        'Vtipná večeře s partou smíchomilů',
        'Společenský večer s blízkými přáteli',
        'Elegantní setkání přátel',
        'Galavečer v přítomnosti přátel',
        'Významná konvence kamarádů',
        'Setkání v humoristickém duchu',
        'Formální večeře s milými společníky',
        'Přátelský pokec při kulturním setkání',
        'Večer elegantního zábavného programu',
        'Setkání v humorném společenství',
        'Hudební soiree se skvělými přáteli',
        'Vznešené setkání s přáteli při kávě',
        'Formální posezení s nejbližšími',
        'Společné chvíle plné vtipů a radostí',
        'Vážná debata i přátelský pokec',
        'Elegantní společenský večer',
        'Hodiny smíchu s nejbližšími přáteli',
        'Setkání plné humoru a úsměvů',
        'Galavečer v top společnosti',
        'Setkání spřízněných duší',
        'Společenský banket v přátelském duchu',
        'Ples společně s přáteli',
        'Noblesní sešlost s kamarády',
        'Humor s elegancí, elegance s humorem',
        'Exkluzivní fórum vtipu a vzdělanosti',
        'Kultivovaná véča s (ne)kultivovanými kamarády',
        'Grandiózní shromáždění přátel',
        'Banket plný výjimečných společníků',
        'Formální gala soubor přátel',
        'Kulturní salon s fantastickými přáteli',
        'Elegantní sešlost s komickým uměním',
        'Přátelské poselství v uměleckém kabaretu',
        'Formální debata o vtipech a radostech',
        'Setkání kultivovaných srdcí plných smíchu',
        'Noblesse vždy pouze s humorem',
        'Slavnostní komedie a přátelská setkání',
        'Formální galavečer s výjimečnými lidmi',
        'Setkání plné legrace',
        'Prostě takový normální sraz',
      ],
    },
    {
      type: 'description',
      data: [
        'Nechte smích rozproudit vaše srdce. Setkání, kde se rodí nezapomenutelné okamžiky plné radosti a přátelství!',
        'Smějte se a tvořte nezapomenutelné vzpomínky s blízkými!',
        'Zábava bez hranic, setkání přátel plného smíchu, spontaneity a nečekaných překvapení!',
        'Radostná jízda plná humoru, vstupte do světa přátelství, kde se smích stává rutinou!',
        'Naplňte svůj život smíchem, setkání, které vás obklopí pozitivní energií, vtipem a přátelstvím!',
        'Spojení srdcí prostřednictvím humoru, setkání s přáteli, kde se okamžitě propojí smích a radost!',
        'Setkání, které rozjasní vaše tváře a zanechá v srdci trvalý úsměv!',
        'Když se setkává vášeň a smích, společně prozkoumejte vlny radosti a přátelství na jedinečném setkání!',
        'Smích jako přísada šťastných chvil, setkání, které vám přinese plno vzácných okamžiků a výbuchů radosti!',
        'Setkání, kde se smích mění na zdroj inspirace a nezapomenutelných vzpomínek!',
        'Přátelské setkání, kde se okamžiky smíchu promění ve vzácné dary života!',
        'Představení radosti, setkání, které vás vezme na cestu plnou zábavy, smíchu a vnitřního rozkvětu!',
        'Objevte kouzelný kruh, společně vytvořte setkání, které propojí přátelství s nekonečným štěstím!',
        'Přátelé na výletě za smíchem, prožijte dobrodružství, kde se každá chvíle stává jedinečným komediálním příběhem!',
        'Smích jako univerzální jazyk, setkání, kde se různé duše spojují v jediném cíli – šíření radosti a přátelství!',
        'Vtipné souznění, setkání plné smíchu, harmonie a vzácných okamžiků sdíleného přátelství!',
        'Vibrace smíchu v jednom tónu, společně se vydejte na hudební cestu přátelstvím a objevte nové melodie radosti!',
        'Zastavte se na okamžik a prožijte setkání, které vás naplní láskou, smíchem a štěstím!',
        'Připojte se k dobrodružství, které překonává hranice a propojuje přátelství v jediné nezapomenutelné zážitkové cestě!',
        'Společenské setkání plné elegance, inspirace a přátelského spojení.',
        'Noblesa a humorná interakce neboli setkání vybraných duší plné vzájemného porozumění.',
        'Formální setkání plné radosti a přátelství, kde se propojují světy i srdce.',
        'Elegantní setkání s přáteli, které oživuje smích a vzájemné pouto.',
        'Kultivované setkání s přáteli plné zábavy a otevřených rozhovorů.',
        'Výjimečný formální večer, kde se rozproudí smích a myšlenky.',
        'Setkání plné novinek a přátelské atmosféry.',
        'Spojení výtvarného umění a přátelství, setkání, které oslavuje kreativitu a radost.',
        'Elegantní forum pro přátelské diskuse a sdílení inspirativních příběhů.',
        'Přátelské setkání, které spojuje vkus, šarm a hlasitý smích.',
        'Společná cesta za formálním setkáním, kde se otevírají dveře ke smíchu a přátelství.',
        'Vzácné setkání, které propojí mysl, srdce, přátele a nezapomenutelné okamžiky.',
        'Formální setkání plné potěšení, zábavy a osobních příběhů.',
        'Vytvořte si nezapomenutelné zážitky na formálním setkání s kámoši.',
        'Spojení kreativního myšlení a přátelského dialogu, setkání, které posouvá hranice.',
        'Elegantní kulturní večer s přáteli, kde se šíří inspirace, smích a dobrá nálada.',
        'Společenské gala plné setkání, která oživují duši a budují věčné vazby.',
        'Formální shromáždění s radostí a interakcí, setkání, které překračuje očekávání.',
        'Vzácné setkání, kde se stýkají vzdělanost, humor a upřímné přátelství.',
        'Necháme smích vyplnit vzduch! Setkání s kámoši plné srandy a nezapomenutelných chvil.',
        'Spojení přátel a bezstarostné zábavy, neformální setkání, které rozjasní den a vykouzlí úsměv na tváři.',
        'Šťastné setkání s partou kámošů, zábava, smích a přátelská atmosféra v jednom balení.',
        'Výlet do světa radosti, setkání s přáteli, kde se každý okamžik promění v komediální příběh.',
        'Přátelé, smích a nekonečné příběhy, setkání, které pohltí do víru radosti a vzácných vzpomínek.',
        'Setkání plné žertů, srandy, společných historek a bezstarostných chvil.',
        'Vlna úsměvů a bláznovství, setkání s přáteli, které roztančí srdce a rozesměje všechny kolem.',
        'Radost a kamarádství na prvním místě, setkání, kde se každý směje, jak nejvíc to jde.',
        'Spontánní setkání plné srandy a pohody.',
        'Chvilky smíchu a přátelství, neformální setkání, kde se všichni cítí jako doma.',
        'Setkání s partou lidí, co se dobře baví a vtipné historky a přátelská nálada jsou na každém rohu.',
        'Společnost plná smíchu a přátelství, setkání, kde se smích stává nejlepším lékem.',
        'Rozpustilá atmosféra a vlna smíchu, setkání s partou kamarádů, kde se na chvíli staneme komiky.',
        'Přátelství, smích a dobrodružství, setkání, které oživí ducha a propojí srdce.',
        'Bezstarostné chvilky s přáteli, setkání plné smíchu, srandy a vytváření nezapomenutelných momentů.',
        'Kámošská oslava s humorem, setkání, kde se šíří radost a každý se cítí jako součást týmu.',
        'Okamžiky smíchu a bláznovství, setkání s partou kamarádů, kde se starosti mění na vtipné historky.',
        'Sdílené úsměvy a komediální příběhy, setkání, které otevírá dveře do světa nekonečného smíchu.',
        'Společná dobrodružství a hlasitý smích, setkání s přáteli, kde se tvoří vzpomínky plné radosti a přátelství.',
        'Sdílené okamžiky radosti, setkání plné smíchu, přátelství a nezapomenutelných vzpomínek.',
        'Setkání, které rozjasní den a propojí srdce i lidi.',
        'Setkání s kámoši, které oživí duši a rozproudí pikantní debaty.',
        'Bezstarostné setkání plné přátelské atmosféry a vzácných chvil sdílení všeho, co nás právě napadne.',
        'Radost ze setkání, společně prožijte okamžiky plné smíchu, pohody a skvělé společnosti.',
        'Chvíle přátelství a spontánních nápadů, kdy se všechno stává zábavou.',
        'Neformální setkání s kámoši, zábavné historky, smích a příjemná nálada.',
        'Sdílená radost a spontánní zábava, setkání, které rozehřeje srdce a rozesměje všechny kolem.',
        'Setkání, které propojuje duše a oslavuje stará dobrá přátelství.',
        'Vytvořte si nezapomenutelné zážitky na setkání plném smíchu, dobrodružství a přátelství.',
        'Společné přátelské dobrodružství, setkání, kde se rodí nezapomenutelné příběhy a vznikají nová pouta.',
        'Radostné shromáždění přátel, setkání, které naplňuje srdce radostí a štěstím.',
        'Vlna smíchu a bezstarostnosti, setkání s partou kámošů, kde se obavy rozplynou ve vzduchu.',
        'Přátelská pohoda a dobrodružství: Setkání, které rozjasní tváře a přináší radost do života.',
        'Oslava přátelství a vzácných okamžiků, setkání, kde se všechno stává důvodem k radosti.',
        'Spontánní setkání s kámoši: Zábava, smích a nezapomenutelné zážitky na každém kroku.',
        'Bezstarostné chvilky s přátel, setkání plné smíchu, vtipů a upřímných rozhovorů.',
        'Svět přátelství a radost, setkání, které zahání šedou a přináší záři do každodenního života.',
        'Spojení srdcí a společné zábavy, setkání, které vytváří vzpomínky, jež vydrží navždy.',
        'Síla přátelství a nekonečný smích, setkání, které rozšíří pohled na svět a otevře nové možnosti.',
        'Probuď v sobě svoje extrovertní já a pojď s námi na setkání s tou nejlepší partou na světě.',
        'Za kovidu jsme nemohli, tak teď se pojďme socializovat ve velkém.',
      ],
    },
    {
      type: 'userName',
      data: [
        'Skvělý Smíšek',
        'Šťastný Šašek',
        'Srandovní Simča',
        'Mr. Vtipko',
        'Veselý Vojta',
        'Zábavná Zuzka',
        'Komik Kamil',
        'Létající Lejla',
        'Šašek Šimon',
        'Veselý Vendy',
        'Smějící se Simona',
        'Žertovný Zdeněk',
        'Vtipná Verča',
        'Přátelský Pepa',
        'Usměvavá Uršula',
        'Humorný Honza',
        'Veselá Vendula',
        'Srandovní Šárka',
        'Vtipný Václav',
        'Skvělý Saša',
        'Veselá Věra',
        'Haha Hana',
        'Žertovný Zbyněk',
        'Srandovní Silvie',
        'Usměvavý Urban',
        'Komická Karolína',
        'Mr. Vtipálek',
        'Šaškující Štěpánka',
        'Veselý Viktor',
        'Smějící se Sabina',
        'Hlasitý Honzík',
        'Zábavná Zlata',
        'Přátelský Pavel',
        'Usměvavá Ulrika',
        'Humorná Helena',
        'Srandovní Stanislav',
        'Vtipná Vanda',
        'Šaškující Simona',
        'Smíšek Stanislav',
        'Vtipná Veronika',
        'Komický Karel',
        'Veselá Vendulka',
        'Usměvavý Uroš',
        'Srandovní Sylvie',
        'Zábavná Zita',
        'Přátelský Patrik',
        'Žertovná Zuzana',
        'Skvělý Štěpán',
        'Humorná Helena',
        'Vtipný Vít',
        'Smějící se Sára',
        'Šašek Samuel',
        'Veselá Verunka',
        'Usměvavý Urban',
        'Srandovní Sabina',
        'Haha Honza',
        'Emil Extrovert',
        'Žertovná Zita',
      ],
    },
  ],
  kultura: [
    {
      type: 'title',
      data: [
        'Kulturní výlet s kamarády',
        'Kultura a přátelská společnost',
        'Přátelské setkání s uměním',
        'Kultura pro kamarády',
        'Přátelské putování za uměním',
        'Společné objevování kulturního světa',
        'Kamarádská kulturní výprava',
        'Kultura spojuje přátele',
        'Setkání s uměleckou tvorbou a kamarády',
        'Přátelské poznávání kulturních klenotů.',
        'Společně za uměním',
        'Kamarádské kulturní dobrodružství',
        'Kulturní putování s přáteli',
        'S kamarády za kulturními zážitky',
        'Přátelské setkání s kulturou',
        'Kamarádská exkurze do uměleckého světa',
        'Přátelské objevování kulturních pokladů',
        'Kultura a přátelství v jednom setkání',
        'S přáteli do světa umění',
        'Kultura bez hranic s kamarády',
        'Přátelské putování kulturními památkami',
        'Kamarádské setkání s historií a uměním',
        'Kulturní procházka s přáteli',
        'Přátelské poznávání místní kultury',
        'Kamarádský výlet do kulturního centra',
        'S přáteli do galerie',
        'Kultura a přátelství v jednom balení',
        'Přátelská cesta za uměním',
        'S kamarády na kulturní misi',
        'Kamarádské setkání s kulturní různorodostí',
        'Kulturní pivo s přáteli',
        'Hledání umění, kultury a kamarádství',
        'Společné výlety za kulturními orgiemi',
        'Kultura a humor s přáteli',
        'Kamarádský útěk do světa umění',
        'Kulturní přestřelka s přáteli',
        'Přátelé z kulturního prostředí',
        'Sblížení pomocí kultury',
        'S přáteli do víru vysoké kultury',
        'Kultura, kterou si přejete sdílet s kamarády',
        'Kultura, kultura a ještě jednou kultura!',
        'Kamarádská kulturní základna',
        'Kultura pro dospělé, děti a jejich kamarády',
        'Kulturní expedice za hranice neznáma',
        'Kamarádský sraz uměleckých outsiderů',
        'Spojení dobrých lidí a dobrého umění',
        'Kulturní napadení: přátelé v útoku na umění',
        'Kamarádský průzkum kulturního bohatství',
        'Kulturní přepadení s kamarády',
        'Chytáme kulturu za pačesy',
        'Výlet za kulturou',
        'Kultura s kamarády, umění a zábava!',
        'Přátelské putování za kulturními objevy',
        'Kulturní výlety s přáteli, objevujeme umění!',
        'S kamarády za uměním a zábavou',
        'Setkání s kulturou, umění, pití a zábava!',
        'Kultura s přáteli, umění a dobré víno',
        'Kulturní akce s přáteli, umění, zábava a překvapení!',
        'Za uměním na neobvyklé výstavy a muzea',
        'Kultura pro kamarády: umění a zábava',
        'Umění, humor a spousta zábavy!',
        'Kulturní zážitky s kamarády, umění a radost!',
        'Přátelská cesta za uměním',
        'S přáteli do světa umění a zábavy',
        'Objevme neobvyklé výstavy a koncerty!',
        'Objevujeme svět umění s kamarády',
        'S přáteli do galerií, umění a zábava bez hranic',
        'Kulturní dobrodružství s přáteli',
        'Přátelské putování za kulturními poklady',
        'Kultura pro kámoše: zábava, umění a víno',
        'Kulturní poznávání s přáteli',
        'S přáteli za uměním a adrenalinem',
        'Umění a radost v srdci',
        'Kultura s přáteli: objevujeme svět umění a zábavy',
        'Kulturní výprava s kamarády, umění, zábava a smích',
        'Přátelské putování za kulturními zážitky',
        'S přáteli do muzeí: umění a zábava pro všechny',
        'Kulturní oslava s přáteli, zábava a spousta lásky',
        'Přátelská cesta za uměním a super zážitky',
        'Objevujeme umění a tajemství světa!',
        'Umění, přátelství a nevšední zážitky',
        'Kultura s přáteli: umění a zábava!',
        'Přátelské putování za kulturními památkami!',
        'S kamarády za uměním a zábavou!',
        'Přátelské setkání s kulturou: umění a zábava!',
        'Kulturní akce s kamarády, zábava a překvapení!',
        'Kultura pro kamarády: umění a zábava!',
        'Přátelské putování za kulturou, umění a zábava!',
        'S přáteli do světa umění a zábavy!',
        'Umělecké zážitky a spousta zábavy!',
        'Přátelské setkání s uměním, objevujeme svět!',
        'Nečekané  kulturní zážitky a historky!',
        'S přáteli za uměním, adrenalinem a nej zážitky!',
        'Přátelské putování za kulturními poklady',
        'Kultura s přáteli, umění a radost v srdci!',
        'Přátelské setkání s kulturou, uměním a legrací!',
        'S kamarády za uměním, objevujeme nové světy!',
        'Kulturní výprava s přáteli, umělecké zážitky a smích!',
        'Přátelská cesta za uměním a kulturou',
        'Kultura s přáteli, uměním a tou nejlepší atmoškou!',
        'Umění, zábava a láskyplné setkání!',
        'Společné nevšední zážitky a nové dojmy',
        'Jeden větší umělec než druhej',
      ],
    },
    {
      type: 'description',
      data: [
        'Připojte se k nám na naší cestě za kulturními zážitky a užijte si přitom skvělý čas s přáteli.',
        'Užijte si skvělý večer plný umění, kultury a skvělé společnosti při naší akci s přáteli.',
        'Připojte se k nám na našem putování plném kulturních zážitků a nezapomenutelné zábavy s přáteli.',
        'Užijte si skvělou kombinaci kulturních zážitků a zábavy s nejlepšími přáteli.',
        'Přijďte za námi na kulturní setkání, kde si užijete nezapomenutelné zážitky s kamarády.',
        'Užijte si skvělou noc plnou umění a zábavy s nejlepšími lidmi, kteří vám toho mohou hodně nabídnout.',
        'Připojte se k nám na putování za uměním, kde si užijete nejenom skvělou kulturu, ale také skvělé jídlo a společnost.',
        'Přijďte se s námi podívat na umělecké výstavy a užijte si nezapomenutelné zážitky s přáteli.',
        'Užijte si skvělý večer plný kulturních zážitků a přátelství s lidmi, kteří mají stejné zájmy jako vy.',
        'Připojte se k nám na kulturním setkání, kde si užijete nejenom umění, ale také spoustu radosti s přáteli.',
        'Zapomeňte na nudné večery a připojte se k nám na našem setkání s kamarády v uměleckém duchu!',
        'Spojte příjemné s užitečným a vydejte se s námi za kulturou! Společně objevíme nové umělecké světy a užijeme si kvalitní čas s kamarády.',
        'Kulturní zážitky jsou nejlepší, když se s nimi můžete pochlubit svým nejlepším kamarádům. Připojte se k nám na setkání za kulturou!',
        'S kulturou je to jako se šampaňským - lepší je ji sdílet s přáteli! Připojte se k nám na nezapomenutelnou kulturní jízdu.',
        'Náš recept na dokonalý večer? Kamarádi, kultura a společné zážitky! Zajděte s námi na kulturní akci a užijte si kvalitní čas se svými nejbližšími.',
        'Pro ty, kteří hledají více než jen nudné večery u televize - připojte se k nám na setkání s kamarády za kulturou! Uvidíte, že to stojí za to.',
        'Prožijte zážitky jako nikdy předtím s vašimi nejlepšími kamarády. Připojte se k nám na nezapomenutelném kulturním setkání.',
        'Když se spojí kulturní zážitky a nejlepší kamarádi, vzniká magie. Připojte se k nám na nezapomenutelném kulturním setkání.',
        'Představte si, že spojíte kulturní zážitky s těmi nejlepšími lidmi. Že to nejde? My vám dokážeme opak, připojte se k nám na našem setkání!',
        'Pro ty, kteří se chtějí pobavit, naučit se něco nového a užít si kvalitní čas s kamarády, připojte se k nám na naší kulturní akci.',
        'Zajděte s námi za kulturou a užijte si nezapomenutelné zážitky se svými nejlepšími kamarády. Objevte umělecké světy a popovídejte si.',
        'Když se kultura a kamarádi spojí, vzniká dokonalá kombinace. Připojte se k nám na kulturním setkání.',
        'Vydejte se s námi na kulturní výlet a získejte nové zážitky, nové myšlenky a nové přátele.',
        'Kultura není jen pro elity, ale pro všechny, kteří chtějí rozvíjet svou mysl. Připojte se k nám a užijte si nezapomenutelné zážitky.',
        'Neexistuje lepší způsob, jak si užít kulturu, než se na ni vydat s kamarády. Připojte se k nám a objevte nové umělecké světy.',
        'Pro ty, kteří se nebojí nových výzev a rádi zkoušejí nové věci - připojte se k nám na kulturní akci. Uvidíte, že to stojí za to.',
        'Kulturní setkání je ideální pro ty, kteří chtějí prozkoumat umělecký svět, učit se něco nového a užít si kvalitní čas s přáteli.',
        'Nejenže kultura obohacuje náš život, ale také spojuje lidi. Připojte se k nám na setkání za kulturou a objevte společné zájmy.',
        'Nudné večery jsou minulostí, připojte se k nám na kulturní akci a užijte si nezapomenutelný zážitek s nejlepšími kamarády.',
        'Když se spojí kulturní zážitky a přátelé, vzniká nezapomenutelná atmosféra. Připojte se k nám a užijte si skvělý večer s kamarády.',
        'Zajděte s námi za kulturou a užijte si příjemné společenské odpoledne s přáteli. Na výběr máte z mnoha uměleckých aktivit.',
        'Pro ty, kteří chtějí uniknout rutině a užít si zážitky s kamarády, připojte se k nám na nezapomenutelné kulturní setkání.',
        'Představte si, že se setkáte se svými nejlepšími kamarády a společně objevíte nové kulturní světy. Přesně to vás čeká na našem setkání.',
        'Připojte se k nám na kulturní cestě plné zábavy, přátelství a nových objevů.',
        'Užijte si nezapomenutelný zážitek s nejlepšími kamarády, kteří sdílejí váš zájem o umění a kulturu.',
        'Objevte nové umělecké světy a získejte nové přátele na našem kulturním setkání.',
        'Spojte své zájmy o umění s přátelstvím a vytvořte nezapomenutelné vzpomínky na našem kulturním setkání.',
        'Naše setkání je ideální pro ty, kteří chtějí trávit čas s přáteli, učit se něco nového a objevovat nové kulturní světy.',
        'Získejte nové perspektivy a užijte si kulturní zážitek s nejlepšími kamarády na našem setkání.',
        'Připojte se k nám na nezapomenutelné kulturní výpravě a prozkoumejte svět umění s vašimi nejlepšími přáteli.',
        'Naše kulturní setkání je pro ty, kteří hledají nové výzvy, chtějí se bavit a objevovat nové světy se svými přáteli.',
        'Nudné večery už neexistují, připojte se k nám na kulturní akci a užijte si nezapomenutelný zážitek se svými nejlepšími kamarády.',
        'Představte si, že se setkáte se svými nejlepšími přáteli a společně objevíte nové umělecké  a kulturní světy.',
        'Spojte zábavu a kulturu na našem setkání s kamarády a užijte si nezapomenutelný večer s novými uměleckými zážitky.',
        'Připojte se k nám na kulturním setkání, kde umění potkává přátelství a nuda má absolutní zákaz.',
        'Když se sejdou nejlepší kamarádi a umění, výsledek je neuvěřitelný, přijďte na naše kulturní setkání.',
        'Nikdy nevíte, co se může stát, když se sejdou kamarádi a kultura, ale zábava a nečekaná překvapení jsou zaručena!',
        'Kultura nikdy nebyla zábavnější, připojte se k nám a užijte si nejlepší umělecké zážitky s vašimi kamarády.',
        'Tentokrát se nechceme jenom kultivovat, ale i bavit, přijďte s námi objevovat umělecké skvosty a zažít pořádnou legraci.',
        'Když se sejdou kamarádi a umění, nastává nekonečná jízda plná kreativity, smíchu a nezapomenutelných zážitků.',
        'Pro ty, kteří nechtějí být kulturou strašeni, ale zábavou okouzleni. Naše kulturní setkání s přáteli je to pravé.',
        'Naše kulturní setkání je jako hra a vy jste vítězem, pokud se bavíte a objevujete nové umělecké světy se svými kamarády.',
        'Pro ty, kteří chtějí být kulturní, ale nechtějí to přehánět, je naše kulturní setkání s přáteli pro vás ideální volba.',
        'Když se setkají kamarádi a umění, nastane nejlepší kombinace vůbec, přijďte a přesvědčte se sami!',
        'Pojďte se s námi ztratit ve světě umění a vychutnat si nezapomenutelné zážitky s vašimi nejlepšími kamarády.',
        'Přijďte s námi objevovat umělecké klenoty a zapomenout na všední dny, naše kulturní setkání je prostě to pravé!',
        'Kulturní setkání s přáteli, kde se kultura stává zábavou a přátelé se stanou kulturními nadšenci.',
        'Když se sejdou kamarádi a umění, očekávejte neuvěřitelné překvapení, připojte se k nám a uvidíte sami!',
        'Naše kulturní setkání s přáteli je jako cesta do nových uměleckých světů, přijďte s námi objevovat tajemství a zábavu.',
        'Když se setkají kamarádi a umění, očekávejte nejlepší kombinaci vůbec, naše kulturní setkání to potvrzuje.',
        'Přijďte s námi prožít kulturní dobrodružství a vytvořit vzpomínky, které budete moci s vašimi kamarády sdílet navždy.',
        'Pro ty, kteří chtějí více než jen pouhou kulturní zkušenost, je naše kulturní setkání s přáteli pro vás jako stvořené.',
        'Když se sejdou kamarádi a umění, připravte se na vzrušující směs zábavy, kreativity a nezapomenutelných okamžiků.',
        'Přijďte s námi na kulturní setkání a přeměňte váš obyčejný den na nezapomenutelné umělecké dobrodružství s kamarády.',
        'Kultura pro kamarády, protože bez kultury jsou kamarádi jen lidi, co spolu posedávají.',
        'Když se kultura potká s kamarády, výsledek je nevyzpytatelný, ale na 100 % zábavný.',
        'Není nic lepšího než kulturní setkání s kamarády, snad jen kulturní setkání s kamarády, kde je zdarma občerstvení.',
        'Když se sejdou kamarádi, dobré jídlo a kultura, výsledek je úžasný a většinou hodně Instagramovatelný.',
        'Připojte se k nám na kulturním setkání s kamarády a zjistěte, že umění a humor jdou ruku v ruce.',
        'Kulturní setkání s kamarády, protože umění není to jediné, co vám může být blízké.',
        'Přijďte na kulturní setkání s kamarády a zjistěte, že kultura a pití dokážou být nečekaně dobrá kombinace.',
        'Když se sejdou kamarádi za kulturou, výsledkem je vždycky dobrá nálada a většinou i nějaké to kulturní povyražení.',
        'Pro ty, kteří chtějí kulturu s dávkou humoru, je naše kulturní setkání s kamarády jako stvořené.',
        'Když se kamarádi sejdou za kulturou, výsledek je většinou směšný, ale v dobrém slova smyslu.',
        'Kulturní setkání s kamarády, protože kultura není vždycky tak vážná, jak si myslíte.',
        'Přijďte se s námi bavit na kulturní setkání s kamarády a zjistěte, že kultura může být i legrační.',
        'Když se kamarádi sejdou za kulturou, většinou se něco zajímavého stane a většinou to není ani úplně umělecké.',
        'Kulturní setkání s kamarády, když se kultura a zábava spojí, může vzniknout něco naprosto úžasného.',
        'Kdo říká, že kultura není zábava? Společně se svými kámoši to rádi dokážeme!',
        'Setkání s kamarády za kulturou je jako terapie pro duši, s jediným rozdílem, že si můžeme sednout a dát si pivo!',
        'Proč si neudělat příjemný večer plný smíchu, piva a kultury s nejlepšími kámoši v okolí?',
        'Když se spojí dobré kamarádství a kulturní zážitky, výsledkem je setkání, na které se nezapomíná!',
        'Když máte v plánu jít za kulturou s přáteli, nic není nemožné a hlavně, nic není lepší!',
        'Naše setkání za kulturou nejsou jen o umění, ale i o těch skvělých přátelských momentech, které se těžko opakují.',
        'Věřte mi, setkání za kulturou s přáteli je nejlepší způsob, jak zapomenout na stres a užít si zábavu.',
        'Proč trávit večer sami, když se můžeme sejít s kamarády a jít za kulturou? Společně to jde líp!',
        'Kulturní setkání s kamarády, kde se setkají kultivovaní blázínci, kteří si užívají života.',
        'Když se sejde parta přátel, nic nebrání tomu si užít kulturu a zároveň se naplno bavit.',
        'Káva, pivo a kultura, proč nezkombinovat všechny tři a užít si skvělý večer se skvělými lidmi?',
        'Potřebujeme něco, co nás vytrhne z každodenního stereotypu, a to kulturní setkání s kamarády rozhodně dokáže.',
        'Náš kulturní výlet se pomalu ale jistě mění na tradici, už se těším na další večer se skvělými lidmi a kulturními zážitky.',
        'Ať už si vybereme koncert, divadelní představení nebo výstavu, jedno je jisté, budeme se bavit a užijeme si společné zážitky.',
        'Kamarádi, kultura a spousta zábavy - nejlépe to jde v kombinaci, tak se zase brzy sejdeme a zažijeme tohle všechno dohromady.',
        'Kulturní výlet s kamarády, nejenže to zní skvěle, ale takový večer si zkrátka musíme užít naplno.',
        'Společné setkání s kamarády, protože člověk potřebuje nejen práci a povinnosti, ale i zábavu a kulturní zážitky.',
        'Kdo by řekl, že si můžeme užít kulturní večer a zároveň si popovídat s kamarády? My to dokážeme.',
        'Když se spojí kultura a kamarádi, vznikne něco neuvěřitelného a my se na to už moc těšíme.',
        'Kulturní setkání s kamarády, protože s dobrou společností je každý zážitek ještě lepší.',
        'Káva, výstava, kulturní podnikání a úžasní kamarádi, to jsou ingredience skvělého večera, na který se těším.',
        'Kultura není jen pro intelektuály, ale pro každého, kdo má chuť na zážitky s kamarády a pořádnou porci zábavy.',
        'Setkání s kamarády a kulturní zážitky, dokonalá kombinace pro perfektní večer.',
        'Už se těším, až zase společně zjistíme, co nám kulturní scéna nabízí a co my můžeme nabídnout jí.',
        'Spojení umění a přátelství, setkání, které oslavuje kreativitu a radost.',
        'Pojďme společně na výstavu, divadelní představení nebo koncert a užijme si společně nezapomenutelné kulturní zážitky.',
        'Těšíme se na naše přátelské setkání,kde si si společně užijeme to nejlepší, co kultura nabízí.',
      ],
    },
    {
      type: 'userName',
      data: [
        'Umělecký Aficionado',
        'Divadelní Dobrodruh',
        'Galerijní Gurmán',
        'Literární Labužník',
        'Melodický Mág',
        'Filmový Fanda',
        'Kultivovaný Kritik',
        'Taneční Talent',
        'Hudební Harmonik',
        'Kreativní Kalibr',
        'Mecenáška Meda',
        'Divotvorný Klobouk',
        'Veselá Píšťala',
        'Kulturní Atašé',
        'Filmový Fanatik',
        'Fanda Kultury',
        'Umělecký Unikát',
        'Kulturní Krotitel',
        'Kreativní Kritik',
        'Literární Lakomec',
        'Galerijní Gigant',
        'Koncertní Klavírista',
        'Hudební Harmonikář',
        'Leonardo',
        'Michelangelo',
        'Salvador Dá-Li',
        'Kulturní Kritik',
        'Umělecký Uchazeč',
        'Divadelní Divoch',
        'Melodický Maestro',
        'Literární Lumír',
        'Výtvarný Virtuóz',
        'Tančící Talent',
        'Fanda Filmový',
        'Hudební Harmonik',
        'Divadelní Diva',
        'Kulturní Náruživec',
        'Klubový Nadšenec',
        'Koncertní Tanečník',
        'Koncertní Tanečnice',
        'Zasloužilý Umělec',
      ],
    },
  ],
  sport: [
    {
      type: 'title',
      data: [
        'Běháme (skoro) jako Zátopek',
        'Když se scházíme, běžíme',
        'Sportovní šílenci',
        'Není to o výhře, ale o pocitu ze závodu',
        'Bez dechu, ale s úsměvem',
        'Běž, skákej, pobav se',
        'Kámošský maraton',
        'Náš sport, naše pravidla',
        'Sportovní výzva s přáteli',
        'Závodíme, ale nebereme to vážně',
        'Běžíme pro pivo',
        'Když se kámoši potkají, sportovat se musí',
        'S přáteli za zdravím a sportem',
        'Pohyb je život, sport s přáteli tím víc',
        'Nepolevujme, sportujme',
        'Nenechte nás sedět, běžíme!',
        'Sportujeme pro radost, nikoli pro výsledek',
        'Nadáváme na běh, ale běháme stále',
        'Kámoši na trati',
        'Více než jen sport je kámošské setkání',
        'Běžíme s úsměvem',
        'Sport s přáteli je nejlepší start do dne',
        'Běháme, abychom mohli jíst víc',
        'Kámoši a sport, neexistuje lepší kombinace',
        'Během proti stresu',
        'Kámošská sportovní horečka',
        'Běh, skok, smích',
        'Za sportem, za zdravím, za kámoši',
        'Kámoši se baví v pohybu',
        'Běháme do party',
        'Když se sejdou sportovci, není co řešit',
        'S přáteli vždycky na startu, vždycky v cíli',
        'Sportovní blázni a jejich dobrodružství',
        'Proč závodit sám, když můžeš závodit s přáteli',
        'Běháme pro zábavu a společnost',
        'Během k lepšímu zdraví',
        'Kámošská sportovní výzva',
        'Kámoši, pohyb a adrenalin',
        'Běh s přáteli je jako rodinná oslava',
        'Zdravé tělo, zdravá mysl, zdravé přátelství',
        'Běháme pro radost a dobrou náladu',
        'Sportujeme společně, zlepšujeme se společně',
        'Kámoši, sport a dobrá nálada',
        'Běhání a kámoši, co víc si přát',
        'Běžíme, skáčeme, smějeme se, žijeme',
        'S přáteli do cíle za každou cenu',
        'Během se bavíme, závodíme a relaxujeme',
        'Kámoši na trati, všichni jsme vítězové',
        'Sportovní den s přáteli',
        'Pohyb a zábava s přáteli',
        'S přáteli za sportem a zdravím',
        'Sportovní výzva pro kamarády',
        'Hrajeme společně',
        'Kámoši na běžeckém stadionu',
        'Sportovní dobrodružství s přáteli',
        'S přáteli na trati',
        'Sportujeme jako kámoši',
        'S přáteli pro zdraví a radost',
        'Běžíme, skáčeme, hrajeme',
        'Sportovní nadšenci a jejich setkání',
        'S přáteli do sportovního světa',
        'Sportujeme s úsměvem',
        'Sport a kámoši, co víc si přát',
        'Kámoši a sportovní energie',
        'Sport a přátelství jdou ruku v ruce',
        'Sportovní zážitky s kamarády',
        'Kámoši na sportovním výletu',
        'Sportovní hřiště a přátelská síla',
        'S přáteli za zdravím a společností',
        'Pohyb a adrenalin s přáteli',
        'S přáteli vždycky na vrcholu',
        'Sportovní zábava s přáteli',
        'Kámoši a sportovní vášeň',
        'Závodíme spolu, ale roste nám přátelství',
        'Sportujeme pro zdraví, sportujeme pro radost',
        'Sportovní nadšenci na akci',
        'S přáteli výš a dál, vždycky spolu',
        'S přáteli na cestě za lepším já',
        'Sportovní zážitky se skvělými kámoši',
        'S kámoši na běžeckém oválu',
        'S přáteli se nikdy nenudíme',
        'Sportovní hrdinové a jejich cesta za vítězstvím',
        'Pohyb a společnost, to jsou kámoši',
        'Sport s nejlepšími kámoši',
        'Kámoši, pohyb a zábava',
        'S přáteli všude, kde se dá sportovat',
      ],
    },
    {
      type: 'description',
      data: [
        'Připojte se k nám na sportovním setkání s přáteli, kde se můžete těšit na soutěže plné adrenalinu a zábavy.',
        'Sportovní klání s nejlepšími kamarády je nejen skvělou příležitostí k fyzické aktivitě, ale také k zábavě a užití si společných okamžiků.',
        'Přidejte se k nám a užijte si skvělou atmosféru na sportovním setkání, kde budeme soutěžit a zažijeme společné chvíle s přáteli.',
        'Sport, přátelé a nezapomenutelné zážitky, to všechno na vás čeká na našem sportovním setkání s kamarády.',
        'Přijďte se pobavit, soutěžit a užít si skvělou společnost na sportovním setkání s přáteli, kde si každý najde to své oblíbené sportovní odvětví.',
        'Sportovní setkání s kamarády je ideální příležitostí k tomu, abychom se společně odreagovali, zlepšili kondici a užili si spoustu zábavy.',
        'Těšíme se na vás na sportovním setkání s přáteli, kde se můžete těšit na skvělou náladu, soutěže a společné aktivity plné adrenalinu.',
        'Přijďte se pobavit a podpořit své kamarády na sportovním setkání, kde se utkáme v různých sportech a prokážeme si své schopnosti.',
        'Sportovní setkání s přáteli je skvělou příležitostí k tomu, abychom si zahráli naši oblíbenou hru a užili si společně chvíle plné soutěžení a radosti.',
        'Těšte se na den plný zábavy a pohybu na sportovním setkání s přáteli, kde se budeme utkávat v různých sportovních aktivitách.',
        'Přijďte si užít přátelské sportovní klání s nejlepšími kamarády a ukažte, co vás na vašem oblíbeném sportu baví nejvíce.',
        'Sportovní setkání s přáteli je nejen příležitostí k tomu, abychom se pohybovali a bavili se, ale také k tomu, abychom posílili naše přátelství.',
        'Přijďte se pobavit, trénovat a utkat se s ostatními na sportovním setkání s přáteli, kde si každý může najít svoji oblíbenou disciplínu.',
        'Těšíme se na vás na sportovním setkání s přáteli, kde si užijeme společné chvíle v pohybu, soutěžení a radost z vítězství.',
        'Sportovní setkání s přáteli je ideální způsob, jak se odreagovat od každodenních starostí, potrénovat a užít si příjemné společenství s lidmi, které máme rádi.',
        'Chcete se společně protáhnout, potit a zároveň pobavit? Přijďte na sportovní setkání s přáteli, kde se utkáme v mnoha sportech.',
        'Přijďte si zasportovat a odreagovat se od stresu naší mladé generace. Tohle sportovní setkání s kamarády je pro to perfektním místem.',
        'Trénujte své svaly a zlepšete svou kondici na sportovním setkání s přáteli. Žádné cvičení v posilovně, jen zábavné aktivity s kamarády.',
        'Přijďte se potit a pobavit se na sportovním setkání s přáteli. Zábava a smích jsou zaručené, tak neváhejte a připojte se k nám.',
        'Na sportovním setkání s kamarády se potkáme a utkáme v různých sportovních disciplínách. Bude to plné zábavy, soutěžení a té nejlepší nálady.',
        'Tento víkend je vhodný čas na sportovní setkání s přáteli, kde se můžete těšit na spoustu zábavy a energie. Tak se přijďte pobavit a zasportovat si.',
        'Připravte se na zábavnou a adrenalinovou sportovní výzvu s kamarády. Nezáleží na tom, jak dobře to umíte, hlavní je společná zábava a soutěžení.',
        'Přijďte se potit, utkat se s přáteli v různých sportech a prokázat své schopnosti na sportovním setkání, které bude plné zábavy, radosti a adrenalinu.',
        'Sportovní setkání s přáteli je ideální příležitostí k tomu, abyste si užili chvíle v pohybu a přitom se těšili na příjemnou společnost svých blízkých.',
        'Toto sportovní setkání s kamarády bude plné zábavy, soutěžení a nezapomenutelných zážitků, tak se k nám připojte!',
        'Chcete se společně protáhnout, potit a zároveň pobavit? Přijďte na sportovní setkání s přáteli, kde se utkáme v nejrůznějších sportech.',
        'Přijďte se potit a pobavit se na sportovním setkání s přáteli. Zábava a smích jsou zaručené, tak neváhejte a připojte se k nám.',
        'Na sportovním setkání s kamarády se potkáme a utkáme se v různých sportech. Bude to plné zábavy a soutěžení, nezapomeňte přinést tu nejlepší náladu.',
        'Tento víkend pořádáme sportovní setkání s přáteli, kde se můžete těšit na spoustu zábavy a energie, tak přijďte ukázat, co vás na sportu baví nejvíce.',
        'Sportovní setkání s přáteli je ideální příležitostí k tomu, abyste si užili společné chvíle v pohybu a soutěžení.',
        'Toto sportovní setkání s kamarády bude plné zábavy, soutěžení a nezapomenutelných zážitků. Co vás ve vašem oblíbeném sportu baví nejvíce?',
        'Přijďte se těšit na sportovní setkání s přáteli plné zábavy a radosti, kde budeme soutěžit, potit se a především se bavit.',
        'Sportujte, utkávejte se a bavte se s přáteli na našem sportovním setkání pro mladé. Každý může ukázat, co v něm je a předvést kvalitní sportovní výkony.',
        'Zažijte skvělou zábavu a relaxaci na sportovním setkání s přáteli. Bude to ideální příležitost k tomu, abyste se vyblbli, potkali nové lidi a pobavili se.',
        'Přijďte prožít nezapomenutelné zážitky a příjemnou atmosféru na našem sportovním setkání pro mladé. Užijete si spoustu zábavy a adrenalinu.',
        'Nechte se unést atmosférou sportovního setkání s přáteli, kde se můžeme těšit na spoustu zábavy, soutěžení a přátelského ducha.',
        'Přijďte se zapotit a zasoutěžit si se svými kamarády na našem sportovním setkání. Bude to plné energie, adrenalinu a samozřejmě zábavy.',
        'Sportovní setkání s přáteli je ideální způsob, jak strávit společný čas a zlepšit své sportovní schopnosti. Užijete si spoustu zábavy a příjemného prostředí.',
        'Na sportovním setkání s přáteli si užijete skvělou zábavu, soutěžení a nezapomenutelné zážitky. Tak neváhejte a přijďte se k nám připojit.',
        'Přijďte si užít sportovní setkání s přáteli, které bude plné zábavy, radosti a soutěžení. Ukažte své sportovní dovednosti a co vás nejvíce baví.',
        'Zažijte adrenalin a spoustu zábavy na sportovním setkání s přáteli. Ideální příležitost k tomu, abyste si užili společný čas s přáteli v pohybu a soutěžení.',
        'Hlasujte s námi o termínu sportovního setkání a užijte si spoustu zábavy, adrenalinu a přátelských soutěží s kamarády.',
        'Připojte se k nám a hlasujte o termínu sportovního setkání, kde si zahrajeme různé sportovní hry a užijeme si přátelského ducha.',
        'Rádi bychom věděli, kdy vám nejlépe vyhovuje sportovní setkání s kamarády. Hlasujte a užijte si společné sportování a přátelskou atmošku.',
        'Hlasujte o termínu sportovního setkání s kamarády a připojte se k nám na přátelských soutěžích a skvělé zábavě.',
        'Nabízíme vám možnost hlasovat o termínu sportovního setkání, kde si zahrajeme různé sporty a užijeme si spoustu zábavy s přáteli.',
        'Neváhejte a hlasujte o termínu sportovního setkání s kamarády. Ukažte své sportovní dovednosti a užijte si spoustu zábavy a adrenalinu.',
        'Sbíráme hlasy na termín sportovního setkání s kamarády. Hlasujte s námi a užijte si spoustu zábavy a přátelského soutěžení.',
        'Zahrajeme si různé sporty a užijeme si spoustu zábavy na našem sportovním setkání s kamarády. Hlasujte o termínu a připojte se k nám.',
        'Hlasujte s námi o termínu sportovního setkání s kamarády a užijte si spoustu zábavy, adrenalinu a přátelského soutěžení.',
        'Soutěžení, zábava a přátelská atmosféra vás čekají na sportovním setkání s kamarády. Hlasujte o termínu a připojte se k nám.',
        'Připojte se k nám na sportovním setkání s kamarády a hlasujte o termínu, který vám nejlépe vyhovuje. Bude to plné zábavy a přátelského ducha.',
        'Hlasujte s námi o termínu sportovního setkání s kamarády a připojte se k nám na spoustu sportovních her a přátelského soutěžení.',
        'Nechte své tělo zapracovat a svou mysl odpočinout na našem sportovním setkání!',
        'Vydejte se na sportovní dobrodružství s kamarády na našem setkání!',
        'Přijďte se pobavit a zasoutěžit si se svými nejbližšími na sportovním setkání!',
        'Získejte nové přátele a zároveň se učte a zkoušejte nové sporty na našem setkání!',
        'Přijďte se setkat s novými lidmi a užít si celodenní sportovní akci!',
        'Chcete se připojit k nejvíce adrenalinovému zážitku v městě? Přijďte k nám na sportovní setkání!',
        'Přeměňte běžný víkend na nejlepší dny svého života na našem sportovním setkání!',
        'Zlepšete své sportovní schopnosti a vytvořte nejlepší tým na našem turnaji na sportovním setkání!',
        'Ukažte, co umíte a získejte vítězství s vašimi kamarády na našem sportovním setkání!',
        'Těšte se na den plný adrenalinu, akce a týmového ducha na našem sportovním setkání!',
        'Přijďte se připojit k nejlepším sportovcům v našem městě na naší sportovní akci!',
        'Využijte skvělou příležitost k relaxaci a zábavě na našem sportovním setkání!',
        'Zlepšete své zdraví a kondici a užijte si nezapomenutelný den s kamarády na našem sportovním setkání!',
        'Získejte nové dovednosti a ukažte, co umíte, na našem sportovním setkání!',
        'Přijďte se pobavit a vytvořte si nezapomenutelné zážitky s kamarády na našem sportovním setkání!',
        'Vydejte se na jedinečnou sportovní výzvu a získejte slávu a úspěch na našem sportovním setkání!',
        'Chcete se setkat s lidmi, kteří mají stejné zájmy jako vy? Přijďte k nám na sportovní setkání!',
        'Ahoj, doraž si zasportovat. Vyber termín, který ti nejvíc vyhovuje a pojď si užít skvělej den.',
        'Pojďme se protáhnout, zasportovat si společně a užít si týmového ducha.',
      ],
    },
    {
      type: 'userName',
      data: [
        'Rychlý Blesk',
        'Sportovní Hvězda',
        'Adrenalinový Šílenec',
        'Vítězný Vítr',
        'Atletický Šampion',
        'Odvážný Střelec',
        'Sprinter',
        'Sportovní Guru',
        'Silový Titan',
        'Energie',
        'Sprinterka',
        'Atletická Šampiónka',
        'Vytrvalý Forrest',
        'Fotbalový Virtuóz',
        'Sportovní Nadšenec',
        'Sportovní Nadšenkyně',
        'Běžecký Maratonec',
        'Fotbalový Fanda',
        'Basketbalová Bestie',
        'Plavčík Profesionál',
        'Hokejový Hrdina',
        'Běžící Sprinter',
        'Golfový Génius',
        'Skvělý Skateboardista',
        'Krasobruslařský Král',
        'Vrcholový Cyklista',
        'Adrenalinový Atlet',
        'Rychlá Raketa',
        'Vrcholová Cyklistka',
        'Pružný Panther',
        'Odvážný Olympionik',
        'Výbušný Vítěz',
        'Hbitá Hvězda',
        'Neúnavný Nadšenec',
        'Sportovní Šampion',
        'Sportovní Vytrvalec',
        'Kulový Blesk',
      ],
    },
  ],
  party: [
    {
      type: 'title',
      data: [
        'Přátelská pařba',
        'Fiesta s přáteli',
        'Parta na párty',
        'Veselé setkání s kamarády',
        'Zábava s kámoši',
        'S kámoši zažijeme něco nevšedního',
        'Kalba s nejlepšími kamarády',
        'Přátelé na párty',
        'Zábava bez hranic',
        'Výjimečná párty s přáteli',
        'S kámoši do noci',
        'Kalba bez ohledu na všechno',
        'S kámoši se vždycky bavíme',
        'Párty, kterou nikdy nezapomeneme',
        'S kámoši pohromadě',
        'Veselá noc s nejlepšími kámoši',
        'Zábavné setkání s přáteli',
        'Přátelé a párty, co víc si přát',
        'Pobavme se jako nikdy předtím',
        'Šampaňské a storky',
        'Mejdan s fellas',
        'Koktejlový Karneval',
        'Rave aperitivů',
        'Hudební happy hour',
        'Bacardi Bash',
        'Margaritaville Madness',
        'Pivní párty',
        'Gin & Tonic Get-Together',
        'Tequila Tantrum',
        'Whiskey Wonders',
        'Šampaňská sláva',
        'Prosecco party',
        'Gastro-gig',
        'Cocktail Carnival',
        'Rum Run',
        'Víno a véča',
        'Mixology Mania',
        'Whisky Weekend',
        'Pivní pouť',
        'Sake soiree',
        'Wine & Cheese Whirlwind',
        'Champagne Jam',
        'Spirited Soirée',
        'Cocktail Conclave',
        'Bourbon Bash',
        'Mojito Madness',
        'Tequila Tempest',
        'Gin Jubilee',
        'Rum Revelry',
        'Beer Bonanza',
        'Wine Wonderland',
        'Whiskey & Wings',
        'Fiesta of Flavors',
        'Martini Mixer',
        'Bubbly Blitz',
        'Sake Sensation',
        'Sangria Soaked Fiesta',
        'Scotch & Cigars',
        'Cider Celebration',
        'Punch Party',
        'Party Pandemonium',
        'Fiesta Frenzy',
        'Cocktail Cataclysm',
        'Booze Bash',
        'Spirited Shindig',
        'Wine Down & Wacky',
        'Sake Slam',
        'Gin & Jazz',
        'Champagne Campaign',
        'Tequila Tango',
        'Whiskey Wishes',
        'Rum Rendezvous',
        'Martini Mania',
        'Punch & Popcorn',
        'Mojito Mingle',
        'Vino & Vinyl',
        'Cider Circus',
        'Bourbon & Burgers',
        'Divoká jízda na oslavě',
        'Fiesta šílenství',
        'Koktejlový zmatek',
        'Alkoholický karneval',
        'Párty pod napětím',
        'Pivní piknik',
        'Víno a zábava',
        'Sake šlágr',
        'Gin a jazz',
        'Kampaň šampaňského',
        'Tequila tango',
        'Přání po whisky',
        'Rumová romantika',
        'Martini manie',
        'Punčová párty',
        'Mojito sešlost',
        'Víno a vinyl',
        'Ciderový cirkus',
        'Bourbon a buřty',
        'Dlouhá noc',
        'Dáme párty?!',
      ],
    },
    {
      type: 'description',
      data: [
        'Připravte se na nezapomenutelnou noc plnou dobrodružství a výzev! Naše párty slibuje koktejlovou smršť a nekonečnou zábavu.',
        'Připravte se na nezapomenutelnou noc plnou dobrodružství a výzev! Přijďte si užít skvělou společnost, fantastické nápoje a jedinečnou atmosféru.',
        'Připravte se na divokou noc plnou exotických nápojů, taneční hudby a šílených her! Naše párty vám poskytne nezapomenutelný zážitek.',
        'Pokud máte rádi nevšední zážitky, naše párty je tím pravým místem pro vás! Přijďte si užít nejlepší koktejly a seznámit se s novými lidmi.',
        'Naše párty je místo, kde se setkáte s nejlepšími lidmi, ochutnáte ty nejchutnější drinky a budete si užívat ty nejlepší taneční hity.',
        'Přijďte oslavit s námi tento neuvěřitelný večer plný koktejlů, her a tance. Naše párty je ideálním místem pro ty, kteří chtějí zcela propadnout hudbě a tanci.',
        'Naše párty je pro ty, kteří si chtějí užít nejlepší zábavu v nejlepší společnosti. Přijďte si vychutnat nejlepší koktejly a najít svůj rytmus na tanečním parketu!',
        'Připravili jsme pro vás večer plný nejlepší hudby, originálních koktejlů a příjemné atmosféry. Naše párty je skvělou příležitostí, jak se setkat s novými lidmi.',
        'Přijďte to rozjet na naší megapárty! Slibujeme, že to stojí za to, nejlepší drinky, nejlepší společnost a možnost slavit až do rána.',
        'Přijďte si s námi užít nezapomenutelnou noc, vystoupíme na pódium a ukážeme vám, jak se tancuje na naší oblíbenou desku s hitovkama 80. let!',
        'Někdo říká, že párty začíná, když myslíte, že už byste měli odejít. Přijďte se přesvědčit, jestli to tak opravdu je.',
        'Zveme vás na párty, kde bude tolik jídla a pití, že se budete muset zastavit na cestě k venkovnímu grilu a dobýt sílu pro další noční dobrodružství!',
        'Máme v plánu večer plný zábavy a smíchu, ale to je jen náš plán. Co se opravdu stane, záleží jen na vás a vašich rozhodnutích, tak přijďte a uvidíte!',
        'Přijďte na párty, kde se bude tancovat až do rána. A pokud nejste fanoušky tance, můžete se připojit k naší stolní hře o nejvíce nechutném koktejlu večera.',
        'Máme pro vás něco skvělého, tajnou ingredienci do každého drinku, která vám dá energii na celou noc. A pokud se nám povede, budem tancovat až do rána!',
        'Víme, že nejlepší párty je ta, kterou oslavíte s nejlepšími kámoši. Přijďte si vychutnat společnost, dobré jídlo a pití, a třeba i nějaké ty taneční kreace!',
        'Přijďte na párty, která vám připomene vaši středoškolskou dobu. Tento večer bude plný hudby, zábavy a skvělých vzpomínek.',
        'Ty a tvoji kámoši jsou pozváni na neuvěřitelnou noc plnou zábavy, jídla a pití! Přijďte si užít nezapomenutelnou párty, na kterou budete dlouho vzpomínat.',
        'Máme pro tebe a tvé kámoše skvělou zprávu, je čas na nejlepší párty v okolí! Přijďte si užít skvělou společnost a zábavu, která vás rozhodně nenechá chladnými.',
        'Nevíš, co dělat tento víkend? Přijď na naši párty s kámošema a užij si nejlepší zábavu v okolí!',
        'Přijďte se s námi bavit, smát se a užít si nejlepší nápoje a jídlo, které jsme pro vás připravili. Tato párty s kámošema bude nezapomenutelná!',
        'Zapomeň na stres a starosti a přijď si užít nejlepší párty v okolí s námi a našimi kámoši! Zaručujeme vám nejlepší zábavu a skvělé vzpomínky.',
        'Máme pro vás připraveno vše, co potřebujete k nezapomenutelnému večeru, dobré jídlo, skvělé pití a samozřejmě skvělou společnost.',
        'Nechte všechny starosti doma a přijďte si užít nejlepší párty s námi a našimi kámoši! Tento večer bude plný zábavy, smíchu a nejlepších drinků.',
        'Zveme vás na nejlepší párty s kámošema v okolí. Přijďte se pobavit, získat nové zážitky a zároveň se setkat se starými přáteli.',
        'Přijďte si užít skvělou párty s námi a našimi kámoši, plnou zábavy, tance a nejlepších drinků. Tento večer bude nezapomenutelný!',
        'Přijďte na naši párty a přidejte se k oslavě toho, že jsme konečně našli ztracenou důležitou věc - náš společný smysl pro humor!',
        'Pozor! Na naší párty je povinná dávka humoru, smíchu a dobré nálady. Pokud jste alergičtí na tyto věci, nechoďte sem!',
        'Naše párty je jako pizza, plná různorodých ingrediencí, vynikající chuť a nejlepší, když se sdílí s kámoši.',
        'Přijďte na naši párty a nechte se unést do světa zábavy, který je vzdálený od reality a plný vtipů a legrace.',
        'Naše párty je jako život, plná výzev, nových zážitků a smyslu pro humor. Přijďte se s námi pobavit!',
        'Přijďte na naši párty a buďte připraveni na výbuchy smíchu, nebezpečné taneční kroky a nejlepší zábavu s kámoši!',
        'Naše párty je jako káva, nejlepší, když je připravena správně a sdílena s těmi nejlepšími lidmi. Přijďte si s námi dát šálek dobré nálady!',
        'Přijďte se s námi bavit a nechte své problémy doma. Tato párty s kámoši bude jako čistá léčba smíchem!',
        'Naše párty je jako vtipný meme, vynikající, když se o něj podělíte s kámoši a všichni se společně rozesmějete. Přijďte si užít zábavu s námi!',
        'Přijď na naši párty, kde se smích spojí s nejlepším jídlem a pitím.',
        'Přichází největší a nejlepší párty sezóny! Připravte se na mnoho dobrodružství, tance, smíchu a také na větší počet lidí než na poslední párty.',
        'Přijďte si užít nejlepší párty, kde vás nebudou trápit žádné nudné rozhovory, protože naše drinky vám dají dostatek odvahy mluvit o čemkoliv.',
        'Přijďte si užít nezapomenutelný večer, kde můžete tancovat, pít a přitom se cítit jako superstar. Jen se unášejte hudbou a nenechte se zastavit!',
        'Je čas na největší a nejlepší párty v okolí se starými i novými přáteli! Kdo ví, třeba se z toho stane nový románek nebo nová nejlepší kamarádka!',
        'Přijďte si užít párty, kterou jste ještě nezažili! Spousta lidí, spousta zábavy a mnoho sladkých nápojů.',
        'Zapomeňte na pracovní stres a přijďte si užít nejlepší párty v okolí, kde budete mít šanci ukázat své taneční dovednosti a vítězit v soutěžích.',
        'Zveme vás na nejlepší párty v okolí, kde se budeme bavit jako nikdy předtím. Tady se budou plnit nejen vaše žaludky a sklenice, ale i vaše přání.',
        'Přijďte si užít nejlepší párty v okolí, kde si můžete dělat, co chcete, ale s jednou výjimkou, bez fotografií na sociálních sítích.',
        'Přijďte na naši párty a dejte si nějaké zdravé jídlo. Jako například pizza, nachos nebo pizza s nachos na vrchu.',
        'Přijďte na naši párty a ukažte nám své nejlepší taneční kroky na ty největší hitovky.',
        'Tuto sobotu jsme rozhodli, že přijmeme jen nejlepší a nejvíce zábavné lidi. Takže pokud jste pozvaní, jste zaručeně králové zábavy.',
        'Přijďte na naši párty a užijte si nejlepší nápoje v okolí. Ale bacha, pokud náhodou uvidíte dvojitě, znamená to, že by to chtělo sklenku vody!',
        'Přijďte se k nám přidat a být součástí legendární párty. Říká se, že všechny nejlepší historky začínají právě tady!',
        'Tuto sobotu se připravte na nejlepší párty v okolí. A pokud se vám podaří zůstat vzhůru až do rána, můžete pak zaspat v pondělí do práce.',
        'Přijďte na naši párty a užijte si tu nejlepší hudbu. A pokud se vám bude zdát, že vám zpívá Adele, můžeme potvrdit, že to bude jen váš opilý kamarád.',
        'Přijďte se s námi bavit a vypnout na největší kalbě s kámoši!',
        'Zapomeňte na starosti a vychutnejte si večer s těmi nejlepšími lidmi!',
        'Sbalte sebou své nejlepší taneční kroky a přijďte se s námi bavit!',
        'Nečekejte na víkend a zažijte s námi párty, na kterou nezapomenete!',
        'Dobré jídlo, pití a spousta smíchu, to vás čeká na naší párty!',
        'Přijďte se s námi bavit a udělat si příjemný večer s přáteli!',
        'Žádné plánování, žádný stres, jen jednoduchá zábava s kámoši!',
        'Připravte se na nejlepší párty roku, samozřejmě s námi!',
        'Tento večer bude plný dobrodružství, smíchu a skvělé společnosti!',
        'Přijďte s námi oslavit nejlepší kámošskou párty v historii!',
        'Přijďte se bavit s námi, protože naše párty je vždycky ta nejvíc rozjetá!',
        'Tento večer bude plný zábavy, tančení a neuvěřitelných překvapení!',
        'Sbalte své nejlepší outfity a připojte se k nám na nejlepší párty ve městě!',
        'Tento večer bude plný skvělé hudby, dobrého jídla a pití a spousty zábavy s kámoši!',
        'Přijďte si užít víkendovou atmosféru na naší skvělé párty s přáteli!',
        'Zapomeňte na nudu a přijďte si užít párty, kterou nikdy nezapomenete!',
        'Nechte se unést atmosférou naší párty a užijte si skvělý večer s kámoši!',
        'Přijďte nám předvést své nejlepší taneční kroky a užijte si skvělý večer s přáteli!',
        'Sbalte své nejlepší party oblečení a připojte se k nám na nejlepší párty ve městě!',
        'Pojďme společně zakalit a užít si nezapomenutelnej večer plnej zábavy s kámoši!',
        'Připoj se k nám na nejlepší párty ve městě a vem všchny svoje nejlepší kámoše s sebou!',
        'Zapomeň na starosti a vychutnej si večer plný zábavy s kámoši!',
        'Přijď se připojit k našemu kámošskému setkání a na chvíli si dopřej únik od reality!',
        'Neváhej a doraz na nejlepší párty ve městě s těmi nejlepšími lidmi, které znáš a nebo poznáš!',
        'Přidej se k nám na večer plný smíchu, dobrého jídla a nezapomenutelných okamžiků s kámoši!',
        'Zapomeň na nudu a doraz na párty, kde si užiješ nejlepší společnost. Neváhej a pojď si užít doopravdy originální zábavu!',
        'Připoj se k nám na večer plný přátelství, dobré hudby a skvělého jídla! Tak přijď s námi oslavit život a užij si nezapomenutelný zážitek!',
        'Pojď si užít bezstarostný večer s těmi nejlepšími lidmi, které znáš!',
        'Neváhej a doraz na párty, která bude plná neuvěřitelných zážitků a nezapomenutelných momentů s kámoši!',
        'Přidej se k nám na večer, kde se setkáš s nejlepšími kámoši a užiješ si skvělou atmosféru!',
        'Zapomeň na stereotypy a doraž na párty, kde se setkáš s těmi nejlepšími lidmi a užiješ si nezapomenutelné chvíle!',
        'Připoj se k nám na večer, kde si užiješ skvělou zábavu a vynikající společnost!',
        'Pojď si užít bezstarostný večer s kámoši, kde budeš mít možnost se bavit a odpočinout si od všedních starostí!',
        'Neváhej a doraz na nejlepší párty ve městě s tvými oblíbenými lidmi a písničkami!',
        'Přidej se k nám na večer, kde si užiješ skvělou hudbu, dobré jídlo a úžasnou společnost s kámoši!',
        'Zapomeň na práci a doraz na párty, která bude plná zábavy a dobré nálady s těmi nejlepšími lidmi!',
        'Připoj se k nám na večer, kde si užiješ skvělou atmosféru a budeš mít možnost se pobavit s nejlepšími kámoši.',
        'Kdo ví, co se může stát na takové obyčejné párty, možná si najdete nové přátele, získáte inspiraci nebo dokonce objevíte novou lásku!',
      ],
    },
    {
      type: 'userName',
      data: [
        'Párty Animal',
        'Tančící Divoch',
        'Divoká Divoženka',
        'Energická Excentrička',
        'Dynamická Dagmara',
        'Divoký David',
        'Běžný Bavič',
        'Rozšafný Bonviván',
        'Pivní Guru',
        'Směšný Šašek',
        'Bleskový Bob',
        'Zábavný Půllitr',
        'Párty Pecka',
        'Kofeinový Král',
        'Vtipný Viking',
        'Pěnový Profesor',
        'Veselá Kopa',
        'Dobrodružný Divoch',
        'Pivní Poeta',
        'Šprýmař Sam',
        'Rychlá Runda',
        'Koktejlová Královna',
        'Espresso Egon',
        'Koketa Jane',
        'Pivní Poutník',
        'Veselý Výtržník',
        'Kofeinový Kumpán',
        'Vtipný Vagabund',
        'Dobrodružný Dravec',
        'Zábavný Zkrocenec',
        'Rychlý Rarášek',
        'Pivní princezna',
        'Nalitej Žok',
        'Pivní Master',
        'Veselá Vtipálka',
        'Neposedná Židle',
        'Barová Židle',
        'Rozverné Martini',
        'Kulatý Stůl',
        'Zakouřený Paravan',
        'Šumivý Šampán',
        'Rychlý Rumburak',
        'Skvělý Šermíř',
        'Parádní Pyrotechnik',
        'Bleskový Bubák',
        'Kouzelný Koktejl',
        'Neohrožený Námořník',
        'Všudybylný Vagabund',
        'Polétavá Šenkýřka',
        'Veselý Šenkýř',
        'Štamgast Míchač',
        'Pivní Příživník',
        'Rozumný Rozumbrada',
        'Báječný Bavič',
        'Přelétavý Přízrak',
        'Kulinářský Kaskadér',
        'Divoký Diskonaut',
        'Pivní Poutník',
        'Chytrá Rozumbrada',
        'Báječný Bonviván',
        'Vtipný Výtržník',
        'Divoký Dravec',
        'Neposedná Nápadnice',
        'Neposedný Nápadník',
        'Pohodový Přítel',
        'Divoká Dravkyně',
        'Noční Zvíře',
        'Pivní Pán',
        'Pivní Paní',
        'Švihák Lázeňský',
      ],
    },
  ],
};
